import { forwardRef, memo, useCallback, useImperativeHandle, useState } from 'react'
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import './UpcomingVisitsSection.scss'
import { useNavigate } from 'react-router-dom'
import {
  EMPTY_UPCOMING_VISITS_SECTION_TEXT,
  PATIENT_UPCOMING_VISIT_DETAILS_ROUTE,
  UPCOMING_VISITS_TEXT,
} from '../../../../utils/constants'
import { ChartSection } from '../chart-section/ChartSection'
import upcomingVisitsIcon from '../../../../images/charts/calendar.png'
import { compareArray } from '../../Utils'
import { VisitCard } from '../visit-card/VisitCard'
import { getPatientUpcomingVisits } from '../../../../store/charts/ChartsThunk'
import { setPatientUpcomingVisits } from '../../../../store/charts/ChartsActions'

export const UpcomingVisitsSection = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  forwardRef(({ id, patientInfo, userTimeZone, patientChartsSearchRow }, ref) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [isCollapsed, setIsCollapsed] = useState(true)
    const [hasOpened, setHasOpened] = useState(false)

    const upcomingVisits = useSelector(
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      (state) => state.chartsReducer?.patientInfo?.[id]?.UpcomingVisits || [],
      compareArray,
    )

    const onClickUpcomingArrow = useCallback(
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      ({ visitId, provider }) => {
        navigate(`${PATIENT_UPCOMING_VISIT_DETAILS_ROUTE}/${visitId}`, {
          state: { patientId: id, visitId, provider, search: patientChartsSearchRow },
        })
      },
      [id, navigate, patientChartsSearchRow],
    )

    const onSetIsCollapsed = () => {
      if (isCollapsed) {
        if ((!upcomingVisits.length || !hasOpened) && patientInfo?.[id]?.VisitSummary?.CountUpcoming) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(getPatientUpcomingVisits(id))
        } else if (!hasOpened) {
          setHasOpened(true)
        }

        if ((upcomingVisits.length || !hasOpened) && !patientInfo?.[id]?.VisitSummary?.CountUpcoming) {
          dispatch(setPatientUpcomingVisits(id))
        } else if (!hasOpened) {
          setHasOpened(true)
        }
      }
      setIsCollapsed((prev) => !prev)
    }

    useImperativeHandle(ref, () => ({
      openUpcomingVisits() {
        setIsCollapsed(false)
      },
    }))

    return (
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      <ChartSection
        className={classnames('upcoming-visits-section', {
          'upcoming-visits-section--empty': !upcomingVisits?.length,
        })}
        title={UPCOMING_VISITS_TEXT}
        icon={upcomingVisitsIcon}
        iconAltText='past-visits'
        setIsCollapsed={onSetIsCollapsed}
        isCollapsed={isCollapsed}
        emptyText={EMPTY_UPCOMING_VISITS_SECTION_TEXT}
        userTimeZone={userTimeZone}
        isWithoutLastUpdated>
        {upcomingVisits?.length ?
          <div className='upcoming-visits-wrapper'>
            {/*
             // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
            {upcomingVisits.map((visit, index) => (
              <VisitCard
                key={visit?.VisitId ?? `upcoming-visit${index}`}
                visit={visit}
                id={`upcoming-visit${index}`}
                clickArrowAction={onClickUpcomingArrow}
                userTimeZone={userTimeZone}
                showStatus
              />
            ))}
          </div>
        : null}
      </ChartSection>
    )
  }),
)
